import { FormEvent } from "react";
import { Col, ControlLabel, FormControl, FormGroup, Label } from "react-bootstrap";

interface IProps {
    alias: string,
    allowEdit: boolean,
    isValid: boolean,
    onChange?: (e: FormEvent<FormControl & HTMLInputElement>) => void
}

const Alias = (props: IProps) => {
    return (
        <FormGroup validationState={props.isValid == false ? 'error' : null}>
            <Col xs={12} lg={2} componentClass={ControlLabel}>Alias (letters/numbers only):</Col>
            <Col xs={12} lg={4}>
                {props.allowEdit ?
                    <FormControl name='alias' minLength={6} maxLength={12} value={props.alias} onChange={props.onChange} />
                    :
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='form-control-static' style={{ marginRight: 20 }}>{props.alias}</div>
                        <Label>Cannot be changed</Label>
                    </div>
                }
            </Col>
        </FormGroup>
    );
}

export default Alias;